module.exports = __webpack_public_path__ + "img/8.dea16a93.jpg";